import { Toast, ToastType } from 'types/toasts'
import { ExtendedChainParams, WalletInternalState } from './useWallet.types'


export const PRODUCTION_NETWORK_PARAMS: ExtendedChainParams = {
  network: 'fantom',
  rpcIndex: 250,
  chainParams: {
    chainId: `0x${Number(250).toString(16)}`,
    chainName: 'Fantom',
    nativeCurrency: {
      name: 'Fantom',
      symbol: 'FTM',
      decimals: 18,
    },
    //rpcUrls: ['https://rpc.ftm.tools/'],
    rpcUrls: ['https://rpcapi.fantom.network'],
    blockExplorerUrls: ['https://ftmscan.com/'],
  },
}

export const TESTNET_NETWORK_PARAMS: ExtendedChainParams = {
  network: 'avalanche-fuji-testnet',
  rpcIndex: 43113,
  chainParams: {
    chainId: `0xa869`,
    chainName: 'Avalanche FUJI',
    nativeCurrency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: 18,
    },
    rpcUrls: ['https://api.avax-test.network/ext/bc/C/rpc'],
    blockExplorerUrls: ['https://testnet.avascan.info/blockchain/c/tx/'],
  },
}

export const ETHEREUM_NETWORK_PARAMS: ExtendedChainParams = {
    network: 'ethereum',
    rpcIndex: 1,
    chainParams: {
        chainId: `0x${Number(1).toString(16)}`,
        chainName: 'Ethereum',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
        },
        rpcUrls: ['https://rpc.ankr.com/eth'],
        blockExplorerUrls: ['https://etherscan.io/'],
    },
}

export const WALLET_INITIAL_STATE: WalletInternalState = {
    currentAccount: '',
    error: '',
    isWalletLoading: true,
    isChainConnected: false,
    isChainAccepted: false,
    isUserConnected: false,
    hasMetamask: false,
    chainId: '',
    targetNetwork: PRODUCTION_NETWORK_PARAMS,
    ethBridgeNetwork: ETHEREUM_NETWORK_PARAMS,
}

export const METAMASK_NOT_FOUND_TOAST: Toast = {
  title: 'Metamask was not found',
  message: 'Please install metamask to connect and use this website.',
  type: ToastType.Error,
}

export const USER_DENIED_CONNECTION_TOAST: Toast = {
  title: 'Could not connect to your wallet',
  message: 'Please connect to metamask to be able to use this website.',
  type: ToastType.Error,
}
